module.exports = __webpack_public_path__ + "static/img/sijie.6c1da81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/touxiang/sijie.png
// module id = fLyO
// module chunks = 0